import Draggable from 'react-draggable';

import {
  ButtonContainer,
  Card,
  StyledButton
} from "@/components/organism/OnboardingDraggableTip/OnboardingDraggableTip.styles";

type OnboardingButton = {
  text: string;
  iconName: string;
  onClick: () => void;
};

type OnboardingDraggableTipProps = {
  show: boolean;
  title: string;
  content: string;
  previousButton?: OnboardingButton;
  nextButton?: OnboardingButton;
};

const OnboardingDraggableTip = ({ show, title, content, previousButton, nextButton }: OnboardingDraggableTipProps) => {
  if (!show) {
    return null;
  }

  return (
    <Draggable>
      <Card>
        <p className="text-size-18 margin-0">{title}</p>
        <div>{content}</div>
        <ButtonContainer>
          {previousButton ? (
            <StyledButton
              type="button"
              className="btn btn-secondary hover border-none"
              onClick={previousButton.onClick}
            >
              <span className={`rioglyph ${previousButton.iconName}`} aria-hidden="true" />
              {previousButton.text}
            </StyledButton>
          ) : null}
          {nextButton ? (
            <StyledButton type="button" className="btn btn-secondary border-color-white" onClick={nextButton.onClick}>
              {nextButton.text}
              <span className={`rioglyph ${nextButton.iconName}`} aria-hidden="true" />
            </StyledButton>
          ) : null}
        </ButtonContainer>
      </Card>
    </Draggable>
  );
};

export default OnboardingDraggableTip;
